import { render, staticRenderFns } from "./epb-button.component.vue?vue&type=template&id=249e9778&scoped=true"
import script from "./epb-button.component.vue?vue&type=script&lang=ts"
export * from "./epb-button.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-button.component.vue?vue&type=style&index=0&id=249e9778&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249e9778",
  null
  
)

export default component.exports